export default __webpack_public_path__ + "static/media/45.d228bfb0.jpg";